"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addFocusRingStyles;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Generates focus ring styles based on provided parameters.
 *
 * @param {Theme} Theme - The theme object.
 * @param {Object} params - Additional parameters for customizing the focus ring.
 * @param {boolean} [params.has_default_rounding=false] - If `true`, sets default focus ring rounding for an element for better appearance. This may be needed when the element does not have its own rounding.
 * @param {string} [params.element_shadow=""] - Adds a shadow value in addition to the focus ring shadow: `box-shadow: [element_shadow,] focusRingShadow`. This may be needed in a situation where an element already has a shadow and needs to be prevented from being overridden by the focus ring.
 * @returns {object} - An object containing CSS styles for the focus ring.
 *
 * @example
 * // Add focus ring styles with default options.
 * "$foo:focus-visible": {
 *   ...addFocusRingStyles();
 * }
 *
 * // Add focus ring styles with custom options.
 * "$foo:focus-visible": {
 *   ...addFocusRingStyles(true, shadow.subtle.lg);
 * }
 *
 * // Add focus ring styles when it needs to be positioned inward of the component. This may be needed when the parent of the interactive element has an `overflow` and clips the focus ring.
 * "$foo:focus-visible": {
 *   position: "relative", // For `::before`.
 *   outline: "none", // Reset `outline` because we don't need it on this element.
 *   "&::before": {
 *     content: "''",
 *     position: "absolute", // Containing block: `foo:focus-visible`.
 *     inset: space.component.focusRing, // Position edge-to-edge of the `foo` element considering the width of the ring.
 *     pointerEvents: "none", // Prevent overlapping above the parent.
 *     ...addFocusRingStyles(true) // Add focus ring styles with default rounding.
 *   }
 * }
 */

function addFocusRingStyles(_ref, _ref2) {
  let {
    busbud: {
      styles
    }
  } = _ref;
  let {
    element_shadow = '',
    has_default_rounding = false
  } = _ref2;
  return _objectSpread(_objectSpread(_objectSpread({}, has_default_rounding && {
    borderRadius: styles.rounding.sm
  }), element_shadow ? {
    boxShadow: element_shadow + ', ' + styles.component.focusRing
  } : {
    boxShadow: styles.component.focusRing
  }), {}, {
    outline: `${styles.borderWidth.sm} solid transparent` // Fallback for forced colors mode.
  });
}